import { InputServico, Servico } from 'common/types/Servico'
import GenericService from '@/shareds/GenericService'
import { ParametrosDeBusca } from 'common/types/Busca'
import { Pagina, Paginacao } from 'common/types/paginacao'

export const PATH_SERVICO = '/servicos'

class ServicoService extends GenericService<Servico, InputServico> {
    constructor() {
        super(PATH_SERVICO)
    }

    async find(_params?: ParametrosDeBusca): Promise<Servico[]> {
        throw new Error('Endpoint usa dados paginados, favor utilizar `findPage`')
    }

    async findPage(params?: ParametrosDeBusca & Partial<Paginacao>) {
		const result = await this.axios.get<Pagina<Servico>>(this.route, {
			params,
		})
		return result.data
    }
}

export default new ServicoService()
